import React from 'react';
import './Contact.css';
import Navbar from '../Navbar/Navbar';
import { FaFacebook, FaLinkedin, FaTwitter } from 'react-icons/fa';
import Footer from '../Footer/Footer';
import axios from "axios";
import { useState } from "react";

const Contact = () => {

  const [formData, setFormData] = useState({
    name: "",
    email: "",
    organization: "",
    subject: "",
    message: "",
  });

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    try {
      const res = await axios.post(
        "https://infosightapi.emedha.in/api/contact",
        formData
      );

      if (res.data === "success") {
        alert("Thank you for contacting us!");
        setFormData({
          name: "",
          email: "",
          organization: "",
          subject: "",
          message: "",
        });
      }
    } catch (err) {
      alert("Failed to submit form");
    }
  };


  return (
    <>
      <Navbar />
      <div className="contact-container">
        <div className="contact-header">
          <h1>Contact Us</h1>
          <p>Thank you for your interest. Please fill out the form below to inquire about our work.</p>
        </div>

        <div className="contact-content">
          {/* Left: Form */}
          <div className="contact-form">
            <form onSubmit={handleSubmit}>
              <div className="form-group">
                <label>Name</label>
                <input type="text"   name="name"  placeholder="Enter your name" value={formData.name} onChange={handleChange}/>
              </div>

              <div className="form-group">
                <label>E-mail</label>
                <input type="email"    name="email" placeholder="Enter your email"  value={formData.email} onChange={handleChange}/>
              </div>

              <div className="form-group">
                <label>Organization</label>
                <input type="text"   name="organization" placeholder="Your organization" value={formData.organization} onChange={handleChange}/>
              </div>

              <div className="form-group">
                <label>Subject</label>
                <input type="text"   name="subject" placeholder="Subject" value={formData.subject} onChange={handleChange}/>
              </div>

              <div className="form-group">
                <label>Describe briefly</label>
                <textarea rows="5"   name="message"  placeholder="Write your message here..." value={formData.message} onChange={handleChange}></textarea>
              </div>

              <button type="submit" className="submit-btn">Let's Get Talking!</button>
            </form>
          </div>

          {/* Right: Contact Details */}
          {/* <div className="contact-details">
            <div className="contact-block">
              <h3>UAE</h3>
              <p>1402, BB1 Tower,<br />Mazaya Business Avenue,<br />Jumeirah Lake Towers, Dubai, UAE.</p>
              <p><strong>Phone:</strong> +971 4 4519958</p>
              <p><strong>Mobile:</strong> +971 55 917 4244</p>
              <p><strong>Email:</strong> info@info-sight.net</p>
              <a href="https://www.google.com/maps?q=Infosight+Consultants" target="_blank" rel="noreferrer">Get directions</a>
            </div>

            <div className="contact-block">
              <h3>Andhra Pradesh - India</h3>
              <p>Infosight, NH16, Tadepalli,<br />Guntur District,<br />Andhra Pradesh - 520012, India</p>
              <a href="https://www.google.com/maps?q=Infosight+Consultants" target="_blank" rel="noreferrer">Get directions</a>
            </div>

            <div className="contact-block">
              <h3>Karnataka - India</h3>
              <p>No.6, J S Complex , Attibele,<br />Sarjapur- Bangalore, Pin 562107. India</p>
              <p><strong>Phone:</strong> +91 9900226979</p>
              <a href="https://www.google.com/maps?q=Infosight+Consultants" target="_blank" rel="noreferrer">Get directions</a>
            </div>
          </div> */}
          <div className="contact-details">
  <div className="contact-block">
    <h3>UAE</h3>
    <p>
      1402, BB1 Tower,<br />
      Mazaya Business Avenue,<br />
      Jumeirah Lake Towers, Dubai, UAE.
    </p>
    <p><strong>Phone:</strong> +971 505141005</p>
    <p><strong>Email:</strong> suresh@info-sight.net</p>
    <a
      href="https://www.google.com/maps?q=Infosight+Consultants"
      target="_blank"
      rel="noreferrer"
    >
      Get directions
    </a>
  </div>

  <div className="contact-block">
    <h3>Andhra Pradesh - India</h3>
    <p>
      Infosight, NH16, Tadepalli,<br />
      Guntur District,<br />
      Andhra Pradesh - 520012, India
    </p>
    <p><strong>Phone:</strong> +91 90357 27034</p>
    <p><strong>Email:</strong> vamsi@info-sight.net</p>
    <a
      href="https://www.google.com/maps?q=Infosight+Consultants"
      target="_blank"
      rel="noreferrer"
    >
      Get directions
    </a>
  </div>

  <div className="contact-block">
    <h3>Karnataka - India</h3>
    <p>
      No.6, J S Complex, Attibele,<br />
      Sarjapur- Bangalore,<br />
      Pin 562107, India
    </p>
    <p><strong>Phone:</strong> +91 90357 27034</p>
    <p><strong>Email:</strong> vamsi@info-sight.net</p>
    <a
      href="https://www.google.com/maps?q=Infosight+Consultants"
      target="_blank"
      rel="noreferrer"
    >
      Get directions
    </a>
  </div>
</div>

        </div>

        {/* Embedded Google Map */}
        <div className="map-container">
          <iframe
            src="https://maps.google.com/maps?q=Infosight+Consultants&amp;iwloc=near&amp;output=embed"
            frameBorder="0"
            style={{ border: 0 }}
            allowFullScreen=""
            loading="lazy"
            title="Company Location"
            referrerPolicy="no-referrer-when-downgrade"
          ></iframe>
        </div>
      </div>

      {/* <footer className="footer">
                  <div className="container footer-content">
                    <p>© {new Date().getFullYear()} MyConsultants. All rights reserved.</p>
                    <div className="socials">
                      <FaFacebook />
                      <FaLinkedin />
                      <FaTwitter />
                    </div>
                  </div>
                </footer> */}

                <Footer/>
    </>
  );
};

export default Contact;
